module.exports = __webpack_public_path__ + "static/media/placeholdenew.b4ae6a44.png";